import { PapiMessage, PapiNcMessage, PapiUser } from '@wix/da-papi-types';
import { users } from '../users';
import { pickone, bool } from '../helpers';

let lastMessageId = 0;

export function makeNCNotification(
  type: string,
  extraFields?: Partial<PapiNcMessage>,
  originator?: PapiUser,
  messageClass: string = 'class.watch'
): PapiNcMessage {
  return {
    // note that this increments the counter so all ids will be guaranteed unique
    messageId: ['id', type, lastMessageId++].join('@'),
    messageClass: messageClass,
    type,
    orphaned: false,
    ts: new Date().toISOString(),
    originator: originator || pickone(users),
    isNew: bool(),
    messageData: {},
    bucket: `bucket.deviation.${['id', type, lastMessageId++].join('@')}`,
    folderId: 1,
    ...extraFields,
  };
}

export function makeNotification(
  type: string,
  extraFields?: Partial<PapiMessage>,
  originator?: PapiUser
): PapiMessage {
  return {
    // note that this increments the counter so all ids will be guaranteed unique
    messageId: ['id', type, lastMessageId++].join('@'),
    type,
    orphaned: false,
    ts: new Date().toISOString(),
    originator: originator || pickone(users),
    isNew: bool(),
    ...extraFields,
  };
}

export function makeStackNotification(
  type: string,
  stackCount: number,
  extraFields?: Partial<PapiMessage>,
  originator?: PapiUser
) {
  const stack: Partial<PapiMessage> = {};
  if (stackCount > 1) {
    stack.stackId = ['stack', type, lastMessageId++].join('@');
    stack.messageId = stack.stackId;
    stack.stackCount = stackCount;
  }

  return makeNotification(type, { ...stack, ...extraFields }, originator);
}
